<template>
	<el-container>
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="tomain()" :src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="tomain()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">预约记录 </span>
		</el-header>
		<div style="height: 100%;">
		<el-table  @row-click="clickTable" :default-sort="{prop: 'bookdate', order: 'descending'}" size="mini" ref="multipleTable"
			tooltip-effect="dark" :data="cusbookedlist" @expand-change="expandChange">
			<el-table-column type="expand">
				<template slot-scope="props">
					<div>
						<el-row>
							<!-- <el-col :span="6">
								<QRCode :txtstr='props.row.checkno' :qrwidth='80' :qrheight='80'></QRCode>
								<span>登记二维码</span>
								</el-col> -->
								<el-col :span="6">
									<button class="brownbuttonsmall" v-if="props.row.bookstatus=='2'"
										@click="toSelBookBranch(props.row)">重</br>新</br>预</br>约</button>
									<button class="brownbuttonsmall" v-if="props.row.bookstatus=='1'"
										@click="CancelBookDetail(props.row)">取</br>消</br>预</br>约</button>
								
								</el-col>
							<el-col :span="18">
								<div>

									<li>
										<span>{{ props.row.cusname }}</span>
										<el-divider direction="vertical"></el-divider>
										<span v-for="item in AdaptSex">
											<span v-if='props.row.cussex==item.value'>{{item.key}}</span>
										</span>
										<el-divider direction="vertical"></el-divider>
										<span v-for="item in AdaptMarry">
											<label v-if='props.row.cusmarry==item.value'>{{item.key}}</label>
										</span>
									</li>
									<!-- <li>
										<span>体检编号：</span>
										<span class="myrowp">{{ props.row.checkno }}</span>

									</li> -->
									<li>
										<span><b>预约类型：</b></span>
										<span class="myrowp">{{ props.row.book_type_name }}</span>
									</li>
									<li>
										<span><b>预约单位：</b></span>
										<span class="myrowp">{{ props.row.corp_name }}</span>
									</li>
									<li><b>预约分院：</b><span class="myrowp">{{ props.row.branch_name }}</span></li>
									<li><b>预约地址：</b><span class="myrowp">{{ props.row.branch_address }}</span></li>
									<li>
										<span><b>所属单位：</b></span>
										<span class="myrowp">{{ props.row.ordername }}</span>
									</li>
								</div>
							</el-col>

						</el-row>
						<el-row>
							<!-- <el-col :span="12">

								<button class="bluebuttonsmall" @click="toSelBookBranch(props.row)">新预约</button>




							</el-col> -->
							
							<el-col :span="24">
								<checknotice></checknotice>
							</el-col>
						</el-row>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="cusname" label="姓名" width="100px"></el-table-column>

			<el-table-column sortable prop="bookdate" label="预约日期" width="100px">
				<template slot-scope="scope">
					<label>{{dateFormat(scope.row.bookdate)}}</label>

				</template>
			</el-table-column>
			<el-table-column prop="bookstatus" label="状态">
				<template slot-scope="scope">
					<div v-for="item1 in BookStatus">
						<label v-if='scope.row.bookstatus==item1.value'>{{item1.key}}</label>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="branch_name" label="预约分院" width="160px"></el-table-column>

		</el-table>
</div>
	</el-container>
</template>

<script>
	import book from '../../apifunction/Book.js'
	import cusinfo from '../../apifunction/OrderCus.js'
	import QRCode from '../qrcode.vue'
	import checknotice from '../Book/CheckNotice.vue'
	export default {
		data() {
			return {
				mobile: '',
				cusbookedlist: [],
				AdaptSex: this.$enums.AdaptSex,
				AdaptMarry: this.$enums.AdaptMarry,
				BookStatus: this.$enums.BookStatus,
				selcheckno: '',
				showbarcodeinfo: ''
			}
		},
		created() {
			this.mobile = this.$route.query.mobile;
			this.ShowBookedDetail();

		},
		components: {
			QRCode,
			checknotice
		},
		// props: ['inmobile'],
		methods: {
			clickTable(row) {
				this.$refs.multipleTable.toggleRowExpansion(row)
			},
			expandChange(row, rws) {
				this.selcheckno = row.checkno;
				// if(rws.length>1)
				// rws.shift()
			},
			dateFormat: function(d) {
				return this.$moment(d).format("YYYY-MM-DD")
			},
			ShowBookedDetail() {
				cusinfo.GetCusForBookedDetail(this.mobile)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.cusbookedlist = JSON.parse(ent.Data);
								// 	this.selcheckno = this.cusbookedlist[0].checkno;
								// 	this.creatQrCode(this.selcheckno)
								// 	this.showbarcodeinfo=this.cusbookedlist[0].cusname+'-'+ this.cusbookedlist[0].checkno

							}
						}
					});
			},
			CancelBookDetail(row) {
				this.$confirm('取消预约后将不可再约此天体检，确定要取消吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					book.CancelBookDetail(row.book_id)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								cusinfo.UpdateCusStatus(row.id, '40')
									.then(res1 => {
										this.ShowBookedDetail();
									});
							}
						});
				})

			},
			toSelBookBranch: function(cus) {
				cusinfo.GetOrderCusByCusID(cus.id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								var data = {
									path: '/SelBookBranch',
									query: {
										ent: JSON.stringify(JSON.parse(ent.Data)[0])
									}
								};
								this.$router.push(data)
							}

						}
					});


			},
			tomain() {
				this.showmenu=true;
				var data = {
					path: '/mainbook',
					query: {
						mobile: this.mobile,
						showmenu:true
					}
				
				}
				this.$router.push(data)
			},
		}
	}
</script>

<style>
</style>
